import React, { useEffect, useState } from "react";
import TimeChart from "./timeChart";
import Modal, { Modal as ResponsiveModal } from "react-responsive-modal";
import { AiOutlineClear } from "react-icons/ai";

import { Container } from "./styles";

function History({ open, onClose, data, currentSize, clearHistory }) {
  const [currentData, setCurrentData] = useState([]);
  const [currentDataIndex, setCurrentDataIndex] = useState();

  useEffect(() => {
    if (Array.isArray(data[currentSize])) {
      let newCurrentData = data[currentSize].map((time, index) => {
        return { attempt: index + 1, time };
      });

      if (newCurrentData.length > 12) {
        newCurrentData = newCurrentData.slice(-12);
      }

      setCurrentData(newCurrentData);
      setCurrentDataIndex(currentSize);
    } else {
      let biggestArray;
      let biggestArraySize = 0;

      data.map((item, index) => {
        if (Array.isArray(item) && item.length > biggestArraySize) {
          biggestArray = index;
          biggestArraySize = item.length;
        }
        return null;
      });

      if (Array.isArray(data[biggestArray])) {
        let newCurrentData = data[biggestArray].map((time, index) => {
          return { attempt: index + 1, time };
        });

        if (newCurrentData.length > 12) {
          newCurrentData = newCurrentData.slice(-12);
        }

        setCurrentData(newCurrentData);
        setCurrentDataIndex(biggestArray);
      }
    }
  }, [currentSize, data]);

  function updateCurrentData(itemIndex) {
    let newCurrentData = data[itemIndex].map((time, index) => {
      return { attempt: index + 1, time };
    });

    if (newCurrentData.length > 12) {
      newCurrentData = newCurrentData.slice(-12);
    }

    setCurrentData(newCurrentData);
    setCurrentDataIndex(itemIndex);
  }

  return (
    <ResponsiveModal open={open}>
      <Modal open={open} onClose={() => onClose()}>
        <Container>
          {currentData.length ? (
            <>
              <div className="buttons">
                <p>Tamanhos de tabuleiro</p>
                {data.map((item, index) => {
                  if (!Array.isArray(item)) return "";

                  return (
                    <button
                      className={index === currentDataIndex ? "selected" : ""}
                      onClick={() => updateCurrentData(index)}
                      key={index}
                    >
                      {`${index}0`}
                    </button>
                  );
                })}
              </div>
              <TimeChart data={currentData} />
              <div className="flex-end">
                <button
                  className="btn-clear"
                  onClick={() => {
                    setCurrentData([]);
                    clearHistory();
                  }}
                >
                  <AiOutlineClear />
                </button>
              </div>
            </>
          ) : (
            <p>
              Ainda não foi registrado nenhum tempo.
              <br />
              Assim que você completar a atividade, seus tempos ficarão salvos e
              poderão ser vistos aqui.
            </p>
          )}
        </Container>
      </Modal>
    </ResponsiveModal>
  );
}

export default History;
